import { useCallback } from 'react'
import { useQuery } from '@tanstack/react-query'
import { postNamedQuery } from '../../../../../service'

async function fetchActivityCodes (clientId) {
  const { data } = await postNamedQuery('coreData', 'execute-redtail-domain-query', {
    query: 'listActivityCodes',
    autoResolveConnection: true,
    clientId,
    request: {}
  })
  return (data?.activity_codes ?? [])
    .filter(c => !c.deleted)
    .map(c => ({ label: c.name, value: c.id }))
}

export default function useActivityCodes (clientId, enabled = true) {
  const { data: options = [] } = useQuery({
    queryKey: ['redtail-activity-codes', clientId],
    queryFn: () => fetchActivityCodes(clientId),
    staleTime: 10 * 60 * 1000,
    enabled: !!clientId && enabled
  })

  const getLabel = useCallback((activityCodeId) => {
    if (!activityCodeId) return null
    const match = options.find(o => o.value === activityCodeId)
    return match?.label ?? null
  }, [options])

  return { options, getLabel }
}
